const BODY_STYLE_DEFAULTS = {
  header_bg:'#1e293b', header_color:'#ffffff', header_font_size:9,
  body_font_size:10, body_line_height:1.8, detail_font_size:9,
  total_bg:'#f8fafc', total_font_size:11,
  final_bg:'#eff6ff', final_color:'#1e293b',
  notes_font_size:10,
  cell_padding_top:6, cell_padding_bottom:6, cell_padding_left:6, cell_padding_right:6,
  column_widths: { no:'', item:'', detail:'', supply_price:'', qty:'', amount:'', consumer_price:'', consumer_amount:'' },
};

function resolveBodyStyle(raw) {
  return { ...BODY_STYLE_DEFAULTS, ...(raw || {}) };
}

function BodyStylePreview({ bodyStyle: rawStyle }) {
  const s = resolveBodyStyle(rawStyle);
  const cp = `${s.cell_padding_top}px ${s.cell_padding_right}px ${s.cell_padding_bottom}px ${s.cell_padding_left}px`;
  const th = { background:s.header_bg, color:s.header_color, fontSize:s.header_font_size, fontWeight:600, padding:cp, border:'1px solid #d1d5db' };
  const td = { padding:cp, border:'1px solid #d1d5db', fontSize:s.body_font_size };
  const tdAlt = { ...td, background:'#fafbfc' };
  const tdNum = { ...td, textAlign:'right', fontWeight:700, fontFamily:'Consolas,monospace' };
  const tdNumAlt = { ...tdNum, background:'#fafbfc' };
  const tdTotal = { ...td, textAlign:'right', fontWeight:700, background:s.total_bg, borderTop:`2px solid ${s.header_bg}`, fontSize:s.total_font_size };
  const tdTotalNum = { ...tdTotal, fontWeight:800, fontFamily:'Consolas,monospace' };
  const tdVat = { ...td, textAlign:'right', background:s.total_bg, color:'#64748b', fontSize:s.total_font_size };
  const tdVatNum = { ...tdVat, fontFamily:'Consolas,monospace' };
  const tdFinal = { ...td, textAlign:'right', fontWeight:800, background:s.final_bg, color:s.final_color, fontSize:s.total_font_size };
  const tdFinalNum = { ...tdFinal, fontFamily:'Consolas,monospace' };

  return (
    <div style={{border:'1px solid #e2e8f0',borderRadius:8,padding:12,background:'#fff'}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:s.body_font_size}}>
        <thead><tr>
          <th style={{...th,textAlign:'center'}}>No</th>
          <th style={{...th,textAlign:'left'}}>품목</th>
          <th style={{...th,textAlign:'left'}}>세부사항</th>
          <th style={{...th,textAlign:'right'}}>합계</th>
        </tr></thead>
        <tbody>
          <tr>
            <td style={{...td,textAlign:'center'}}>1</td>
            <td style={{...td,fontWeight:700}}>SPA-3100</td>
            <td style={{...td,fontSize:s.detail_font_size,lineHeight:s.body_line_height}}>처리속도: 500MB/s<br/>NIC: GbE 4포트</td>
            <td style={tdNum}>24,000,000</td>
          </tr>
          <tr>
            <td style={{...tdAlt,textAlign:'center'}}>2</td>
            <td style={{...tdAlt,fontWeight:700}}>NMS-500</td>
            <td style={{...tdAlt,fontSize:s.detail_font_size,lineHeight:s.body_line_height}}>관리노드: 500대</td>
            <td style={tdNumAlt}>3,500,000</td>
          </tr>
          <tr><td colSpan={3} style={tdTotal}>합 계</td><td style={tdTotalNum}>27,500,000</td></tr>
          <tr><td colSpan={3} style={tdVat}>부가세 (10%)</td><td style={tdVatNum}>2,750,000</td></tr>
          <tr><td colSpan={3} style={tdFinal}>부가세 포함 합계</td><td style={tdFinalNum}>30,250,000</td></tr>
        </tbody>
      </table>
    </div>
  );
}

export { BODY_STYLE_DEFAULTS, resolveBodyStyle };
export default BodyStylePreview;
